import { APIManager } from './api/manager'

export const APIClient = new APIManager()
